interface ConnectionWarningProps {
  message?: string;
}

export function ConnectionWarning({
  message = "Unable to load data \u2014 the hub may be offline.",
}: ConnectionWarningProps) {
  return (
    <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 text-center">
      <div className="flex items-center justify-center gap-2">
        <svg
          className="h-5 w-5 text-amber-500 flex-shrink-0"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
          />
        </svg>
        <p className="text-sm text-amber-800">{message}</p>
      </div>
    </div>
  );
}
